import React, { useEffect, useState } from 'react';
import { listUpcomingEvents, listPastEvents } from '../../utils/events';
import { Link } from 'react-router-dom';

const SectionTitle = ({ children, action }) => (
	<div className="flex items-center justify-between mb-4">
		<h3 className="text-2xl font-bold text-gray-900">{children}</h3>
		{action}
	</div>
);

const EventCard = ({ eventItem }) => {
	const start = eventItem.startAt?.toDate ? eventItem.startAt.toDate() : new Date(eventItem.startAt);
	const end = eventItem.endAt?.toDate ? eventItem.endAt.toDate() : new Date(eventItem.endAt);
	return (
		<Link to={`/events/${eventItem.id}`} className="block group">
			<div className="rounded-lg border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
				{eventItem.bannerImageUrl && (
					<div className="h-40 w-full bg-gray-100 overflow-hidden">
						<img src={eventItem.bannerImageUrl} alt={eventItem.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
					</div>
				)}
				<div className="p-4">
					<p className="text-sm text-[rgb(130,88,18)] font-semibold">
						{start.toLocaleDateString()} • {start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
					</p>
					<h4 className="mt-1 text-lg font-semibold text-gray-900">{eventItem.title}</h4>
					<p className="mt-1 text-sm text-gray-600 line-clamp-2">{eventItem.description}</p>
					<p className="mt-2 text-sm text-gray-700">{eventItem.isOnline ? 'Online' : eventItem.location}</p>
				</div>
			</div>
		</Link>
	);
};

function EventsSection() {
	const [upcoming, setUpcoming] = useState([]);
	const [past, setPast] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let mounted = true;
		(async () => {
			try {
				const [up, pa] = await Promise.all([
					listUpcomingEvents({ max: 6 }),
					listPastEvents({ max: 6 })
				]);
				if (!mounted) return;
				setUpcoming(up);
				setPast(pa);
			} catch (e) {
				console.error('Failed to load events', e);
			} finally {
				if (mounted) setLoading(false);
			}
		})();
		return () => { mounted = false; };
	}, []);

	if (loading) return null;

	return (
		<section className="py-10">
			<div className="flex items-end justify-between mb-6">
				<h2 className="text-3xl font-extrabold text-gray-900">Events</h2>
				<Link to="/events" className="text-[rgb(130,88,18)] hover:underline font-medium">View all</Link>
			</div>

			{upcoming.length > 0 && (
				<div className="mb-8">
					<SectionTitle action={<Link to="/events" className="text-sm text-[rgb(130,88,18)] hover:underline">See more</Link>}>Upcoming</SectionTitle>
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
						{upcoming.map(ev => <EventCard key={ev.id} eventItem={ev} />)}
					</div>
				</div>
			)}

			{past.length > 0 && (
				<div>
					<SectionTitle action={<Link to="/events?tab=past" className="text-sm text-[rgb(130,88,18)] hover:underline">See more</Link>}>Past events</SectionTitle>
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
						{past.map(ev => <EventCard key={ev.id} eventItem={ev} />)}
					</div>
				</div>
			)}
		</section>
	);
}

export default EventsSection;
